import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Pagination } from "../../shared/pagination.model";
import { BaseApiTemplateService } from "../../shared/base-api-template-service.model";
import { PagingResponseModel } from "../../shared/api-response.model";
import { Core2Config } from "../../shared/core2Config";

import { ApiVisa } from "../../shared/api-visa.model";
import { Observable } from "rxjs";
import { StockReplenishmentRunOrderQtyLineModel } from "../../../../../../models/aggregates/erp/stock/stock-replenishment-run-order-qty-line.model";

@Injectable({ providedIn: "root" })
export class StockReplenishmentRunOrderQtyLineService extends BaseApiTemplateService<StockReplenishmentRunOrderQtyLineModel> {
  constructor(theHttp: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "stock-replenishment-run-order-qty-lines/backoffice-ep";
    this.endpoint_path =
      Core2Config.TENANT_DOMAIN_URL_PREFIX +
      Core2Config.ERP_PREFIX +
      "stock-replenishment-run-order-qty-lines/backoffice-ep";
    this.httpClient = theHttp;
  }
}
